import { render } from "./AppIcons.vue?vue&type=template&id=4cd370e7"
import script from "./AppIcons.vue?vue&type=script&lang=js"
export * from "./AppIcons.vue?vue&type=script&lang=js"

import exportComponent from "/builds/pirago/gon/gon-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
